import { createFileRoute } from '@tanstack/react-router';
import { XeroPanel } from '../../../../features/settings/components/XeroPanel';

/** Xero connection + mappings + push/pull action surface (BUILD_SPEC.md §5.9,
 * §12) — the actual page at `/settings/xero` (index child of the
 * `../xero.tsx` layout, matching silo-counts/counts/index.tsx's identical
 * precedent). Feature-flagged: fully PENDING-safe until Stuart provisions the
 * Xero app credentials (progress.md "Awaiting external"). Plan.md G26. */
export const Route = createFileRoute('/_authenticated/settings/xero/')({
  component: XeroPanel,
});
